import {
  ManagerReportItem,
  Relationship,
  UserFilter,
} from "@coaching-culture/types";
import axios from "axios";
import qsStringify from "qs-stringify";
import { useMutation, useQuery, useQueryClient } from "react-query";

export const getManagerReport = (filter: UserFilter) =>
  axios
    .get<
      ManagerReportItem[]
    >(`/api/v2/reports/managers?${qsStringify({ filter } as any)}`)
    .then(({ data }) => data);

export const useManagerReport = (filter: UserFilter) =>
  useQuery(["manager-report", filter], () => getManagerReport(filter), {
    keepPreviousData: true,
  });

export async function getAllRelationships(): Promise<Relationship[]> {
  return axios
    .get<Relationship[]>("/api/relationships")
    .then(({ data }) => data);
}

export const useMyRelationships = () =>
  useQuery("myrelationships", getAllRelationships);

export const acceptRelationship = (id: string) => {
  return axios.put(`/api/relationships/${id}/accept`);
};

export const deleteRelationship = (id: string) => {
  return axios.delete(`/api/relationships/${id}`);
};

export const useAcceptRelationship = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(acceptRelationship, {
    onSuccess: () => {
      queryClient.invalidateQueries("myteam");
      queryClient.invalidateQueries("myrelationships");
    },
  });

  return mutation;
};

export const useDeleteRelationship = () => {
  const queryClient = useQueryClient();

  // When this mutation succeeds, invalidate any queries with the `todos` or `reminders` query key
  const mutation = useMutation(deleteRelationship, {
    onSuccess: () => {
      queryClient.invalidateQueries("team");
      queryClient.invalidateQueries("myrelationships");
    },
  });

  return mutation;
};
